import { useMutation } from '@tanstack/react-query'

import { del } from 'utils/http'

export const useDeleteUser = () => {
  return useMutation({
    mutationFn: (userId: any) => del(`/management/users/${userId}`),
  })
}
